
/*
(function($) {
    $(document).ready(function(){

    });
})(jQuery);
*/


$(document).ready( function () {

    // run datatable
    if ($.isFunction($.fn.DataTable)) {
        $('.certificant-table').DataTable({
            searching: false,
            ordering: false,
            lengthChange: false
        });
    }




    /**
     * regonline-links
     */
    var reg_container = $('.regonline-links');
    var reg_years = reg_container.find('[name="regonline-years"]');
    var reg_quarters = reg_container.find('[name="regonline-quarters"]');
    //var reg_link = reg_container.find('.regonline-url');

    var reglinks =  function(){
        var year = reg_container.find('select[name="regonline-years"] :selected').val();

        // set quarter dropdown = blank
        reg_quarters.find(':first-child').prop('selected', true);

        // blank out any existing link shown
        //reg_link.html('');

        if( year ) {
            reg_quarters.prop('disabled', false);
            reg_quarters.find('option').each( function(){

                if( $(this).data('year') == year || typeof $(this).data('year') === 'undefined' ) {
                    $(this).show();
                } else {
                    $(this).hide();
                }

            });
        } else {
          //reg_link.html('');
          reg_quarters.prop('disabled', true);
        }

    };


    // run once on init
    reglinks();




    reg_years.on('change blur', reglinks);

    reg_quarters.on( 'change', function(){
        var url = $(this).find(':selected').data('url');
        if( url ) {
            //reg_link.html( '<a href="' + url + '">' + url + '</a>');
            window.open(url);
        }

    });

} );